export default __webpack_public_path__ + "static/media/icon-overview-white.fcdef781.svg";